import { render, staticRenderFns } from "./messageItem.vue?vue&type=template&id=980b61bc&scoped=true"
import script from "./messageItem.vue?vue&type=script&lang=js"
export * from "./messageItem.vue?vue&type=script&lang=js"
import style0 from "./messageItem.vue?vue&type=style&index=0&id=980b61bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "980b61bc",
  null
  
)

export default component.exports